import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import {
  getRouteLoadingData,
  JssStateMainContentLoaded,
} from '@core/jss-routing';
import { InnogyComponentRendering } from '@core/jss-models';
import { getItemLinkFieldValue } from '@core/jss-utils';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'wl-colset-mijn-363',
  templateUrl: './colset-mijn-363.component.html',
  host: { ngSkipHydration: 'true' },
  styleUrls: [
    './colset-mijn-363.component.ed.scss',
    './colset-mijn-363.component.essent.scss',
  ],
})
export class ColsetMijn363Component implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rowSpacing?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptionsLeft?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptionsCenter?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptionsRight?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() columnOptionsLeft?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() columnOptionsCenter?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() columnOptionsRight?: string;

  route$ = this.store$.pipe(select(getRouteLoadingData));

  constructor(private readonly store$: Store<any>) {}

  ngOnInit() {
    this.renderingToModel(this.rendering);
    this.mapColumnCssClasses(this.rendering);
  }

  onLoaded() {
    this.store$.dispatch(new JssStateMainContentLoaded());
  }

  private renderingToModel(rendering: InnogyComponentRendering | undefined) {
    if (rendering == null || rendering.fields == null) {
      return;
    }

    this.rowSpacing = getItemLinkFieldValue(rendering.fields, 'rowSpacing', '');

    // first set theming options if selected
    this.contentOptionsLeft = getItemLinkFieldValue(
      rendering.fields,
      'backgroundThemeLeft',
      ''
    );

    this.contentOptionsLeft +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textThemeLeft', '');

    // first set theming option if selected
    this.contentOptionsRight = getItemLinkFieldValue(
      rendering.fields,
      'backgroundThemeRight',
      ''
    );

    this.contentOptionsRight +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textThemeRight', '');

    // first set theming option if selected
    this.contentOptionsCenter = getItemLinkFieldValue(
      rendering.fields,
      'backgroundThemeCenter',
      ''
    );

    this.contentOptionsRight +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textThemeCenter', '');

    // Set sticky on column if selected
    this.columnOptionsRight = getItemLinkFieldValue(
      rendering.fields,
      'stickyColumnRight',
      ''
    );
    this.columnOptionsCenter = getItemLinkFieldValue(
      rendering.fields,
      'stickyColumnCenter',
      ''
    );
    this.columnOptionsLeft = getItemLinkFieldValue(
      rendering.fields,
      'stickyColumnLeft',
      ''
    );
  }

  private mapColumnCssClasses(rendering: InnogyComponentRendering | undefined) {
    if (rendering == null || rendering.fields == null) {
      return;
    }

    const stickyColumnRightValue = getItemLinkFieldValue(
      rendering.fields,
      'stickyColumnRight',
      ''
    );

    if (stickyColumnRightValue === 'show-on-bottom-mobile') {
      this.columnOptionsRight = 'order-3 mt-3 mt-lg-0';
    } else if (stickyColumnRightValue === 'sticky-mobile') {
      this.columnOptionsRight =
        'sticky-top anchor-sticky-to-header position-lg-static';
    } else if (stickyColumnRightValue === 'sticky-all') {
      this.columnOptionsRight = 'sticky-top anchor-sticky-to-header';
    }
  }
}
